import { Routes, Route, Navigate } from 'react-router-dom'
import { useState } from 'react'
import Layout from './components/Layout'
import ImageAnnotationPage from './pages/ImageAnnotationPage'
import StatsPage from './pages/StatsPage'
import { AnnotationStatus, SpaceType } from './types'
import './App.css'

function App() {
  const [annotatorId, setAnnotatorId] = useState<string>(() => {
    // Get annotator ID from localStorage or default
    return localStorage.getItem('annotatorId') || 'annotator_' + Math.random().toString(36).substr(2, 9)
  })

  // State for search and filters to pass to Layout for export
  const [searchTerm, setSearchTerm] = useState('')
  const [statusFilter, setStatusFilter] = useState<AnnotationStatus | 'all'>('all')
  const [approverStatusFilter, setApproverStatusFilter] = useState<string>('all')
  const [projectFilter, setProjectFilter] = useState<string>('all')
  const [currentSpace, setCurrentSpace] = useState<SpaceType>('annotator')

  // Save annotator ID to localStorage when it changes
  const handleAnnotatorIdChange = (newId: string) => {
    setAnnotatorId(newId)
    localStorage.setItem('annotatorId', newId)
  }

  return (
    <Layout 
      annotatorId={annotatorId} 
      onAnnotatorIdChange={handleAnnotatorIdChange}
      searchTerm={searchTerm}
      statusFilter={statusFilter}
      projectFilter={projectFilter}
      currentSpace={currentSpace}
      onSpaceChange={setCurrentSpace}
      approverStatusFilter={approverStatusFilter}
    >
      <Routes>
        <Route 
          path="/" 
          element={
            <ImageAnnotationPage 
              annotatorId={annotatorId}
              onSearchChange={setSearchTerm}
              onStatusFilterChange={setStatusFilter}
              onProjectFilterChange={setProjectFilter}
              currentSpace={currentSpace}
              onApproverStatusFilterChange={setApproverStatusFilter}
            />
          } 
        />
        <Route 
          path="/stats" 
          element={<StatsPage />} 
        />
        <Route 
          path="*" 
          element={<Navigate to="/" replace />} 
        />
      </Routes>
    </Layout>
  )
}

export default App 